<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="container">
            <div class="box">
                <div class="label">Day Progress</div>
                <div class="value">{{ dayProgress }}</div>
                <div class="unit">%</div>
            </div>
    
            <div class="box">
                <div class="label">Activity Progress</div>
                <div class="value">{{ activityProgress }}</div>
                <div class="unit">%</div>
            </div>
    
            <div class="box">
                <div class="label">Cost Progress</div>
                <div class="value">{{ costProgress }}</div>
                <div class="unit">%</div>
            </div>
    
            <div class="box">
                <div class="label">Current Rate of Well Completion</div>
                <div class="value">{{ rateWellCompletion }}</div>
                <div class="unit">m/day</div>
            </div>
    
            <div class="box">
                <div class="label">Current Cost per Meter</div>
                <div class="value">{{ costPerMeter }}</div>
                <div class="unit">USD/m</div>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import { authComputed } from '@state/helpers'
// import qs from 'querystring'
// import {DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow} from 'devextreme-vue/responsive-box'

export default {
    page: {
        title: 'Dashboard',
        meta: [{ name: 'description', content: appConfig.description }],
    }, 
    components: {PageHeader, Layout},
    props: {
        // wellId: {type: Number, default: undefined}
    },
    data() {
        return {
            title: "Drilling Progress Summary",
            items: [
              {text: 'Home', to: { name: 'home'},},
              {text: 'Dashboard', to: { name: 'dashboard'},},
              {text: 'Drilling Progress',},{text: 'Progress Summary',}
            ],
            wellId: undefined,
            sumHours: undefined,
            finalEndMd: undefined,
            activityProgress: undefined,
            sumRealizedCost: undefined,
            sumPlannedCost: undefined,
            sumPlannedDays: undefined,
            refDate: undefined,
            lastSubmitId: undefined,
        }
    },
    computed: {
        ...authComputed,
        dayProgress() {
            const value = this.sumHours / this.sumPlannedDays
            return value !== undefined ? value.toFixed(1) : 0
        },
        costProgress() {
            const value = this.sumRealizedCost / this.sumPlannedCost
            return value !== undefined ? value.toFixed(1) : 0
        },
        rateWellCompletion() {
            const value = this.finalEndMd / this.sumHours
            return value !== undefined ? value.toFixed(0) : 0
        },
        costPerMeter() {
            const value = this.sumRealizedCost / this.finalEndMd
            return value !== undefined ? value.toFixed(0) : 0
        },
    },
    watch: {
        wellId() {
            this.load()
        },
        lastSubmitId() {
            this.getCostCumulative()
            this.getGeneralReport()
        }
    },
    created() {
        this.wellId = this.currentWell.wellId
        // this.load()
    },
    methods: {
        load() {
            let url=mapApiUrl("/api/form/master/operation-summary/get-sum-hours-endmd")
            axios.get(url, {params: {wellId: this.wellId}})
                 .then(response => {
                     this.sumHours = response.data[0][0]  // response.data is inherently an array
                     this.finalEndMd = response.data[0][1]
                 })
            this.getWellBudget()
            this.getPlannedDays()
            this.getLatestMasterReport()
        },
        getCostCumulative() {
          const url = mapApiUrl('/api/form/master/cost/get-cum-well-cost-to-date')
          let params={wellId: this.wellId, refDate: this.refDate.substring(0,10)}
          axios.get(url, {params: params})
               .then((response) => {
                    this.sumRealizedCost = response.data
                })
        },
        getPlannedDays() {
          const url = mapApiUrl('/api/form/planner/activity/get-sum-days')
          let params={wellId: this.wellId}
          axios.get(url, {params: params})
               .then((response) => {
                    this.sumPlannedDays = response.data
                })
        },
        getWellBudget() {
          axios.get(mapApiUrl("/api/form/master/general/get-well-budget"),
            {params: {wellId: this.wellId}})
            .then((response) => {
              if (response.data) {
                this.sumPlannedCost = response.data
              }
            })

        },
        getlatestSubmitId() {
          const url = mapApiUrl('/api/form/master/list/map')
          let params={wellId: this.wellId}
          axios.get(url, {params: params})
                .then((response) => {
                    this.lastSubmitId = response.data.at(-1).submitId
                })
        },
        getLatestMasterReport() {
          const url = mapApiUrl("/api/form/master/get-latest")
          let params={wellId: this.wellId}
          axios.get(url, {params: params})
                .then((response) => {
                    this.lastSubmitId = response.data.submitId
                    this.refDate = new Date(response.data.dateReport).toISOString().substring(0,10)
                })
        },
        getGeneralReport() {
          const url = mapApiUrl('/api/form/master/general/get')
          let params={submitId: this.lastSubmitId}
          axios.get(url, {params: params})
               .then((response) => {    
                   this.activityProgress = response.data.percentActivityCompleted
              })
              
        },
    }
}
</script>
<style scoped>
    .container {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }

    .box {
        width: 350px;
        height: 200px;
        border: 3px solid #444;
        border-radius: 15px;
        background: white;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        text-align: center;
    }

    .label {
        font-size: 24px;
        font-weight: bold;
        color: #555;
        margin-bottom: 10px;
    }

    .value {
        font-size: 42px;
        font-weight: bold;
        color: #0066cc;
    }

    .unit {
        font-size: 24px;
        font-weight: bold;
        color: #0066cc;
    }
</style>